import React, { useContext, useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { Box } from '@mui/material';

import envirolabLogo from 'resources/images/Envirolab-family-330x150.png';
import { AccessDataContext } from '../../../../contextProviders/AccessDataContext';
import '../../Login.scss';

const Verify = () => {
    const [ searchParams ] = useSearchParams();
    const verifyToken = searchParams.get("token");
    const { verifyUser } = useContext(AccessDataContext);
    const [ verified, setVerified ] = useState(false);
    const [error, setError] = useState<string>(null);
   
    useEffect(() => {
      verifyUser(verifyToken).then(data => {
        if (data?.message){
          setVerified(true);
        }
        else if(data?.errorMessage){
          setError(data.errorMessage);
        }
      }); 
    }, [verifyUser, verifyToken])
  return (
    <Box id="loginBox">
      <Box className="imageBox">
        <img alt="Envirolab logo" src={envirolabLogo} />
      </Box>
      { verified ? <Box className="successBox">Account has been verified. Please click <Link to="/">here</Link> to login</Box> : null }
      { error ? <Box className="errorBox">Verification Token is invalid</Box> : null}
    </Box>
  )
}
export default React.memo(Verify)